import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE, DATE_TIME, CALENDAR_PERIOD } = DataType

/**
 * Makes necessary adjustments to ChartDesignerBreakdown.datasetFields to make
 * sure the settings are still appropriate. For example, it may auto-select a
 * date fields for a calendar period breakdown when there the dataset only has
 * a single date field
 *
 * @param {ChartDesigner} chart
 */
function adjustBreakdownDatasetFields (chart) {
	if (chart.hasMultipleDatasetSources()) {
		chart.breakdowns.forEach(b => {
			if (!b.isCalendarPeriodBreakdown()) {
				// #45978 we found a non-calendar breakdown; we need to
				// basically clear this out, but leave basic info, so it shows
				// in an error state
				b.resetToCalendarBreakdown()
			} else {
				// #45977 if the chart now has multiple dataset references, remove any
				// breakdown repeat by's that use "same field"
				const datasetFields = _.filter(b.get('datasetFields'), f =>
					f.serieId || f.serieTempId)

				// #57189 the breakdown itself should not have a "shared"
				// datasetFieldId or a datasetId because each datasetField will
				// need its own breakdown field, info contained in
				// Breakdown.datasetFields
				b.set({
					datasetFields,
					datasetFieldId: null,
					datasetId: null
				})
			}

		})
	} else if (chart.hasDatasetSources() && hasCalendarBreakdown(chart)) {
		// #45349 We have 1 dataset source and a calendar breakdown; make sure
		// the breakdown references the dataset's date field if there is only 1
		const dataset = chart.getDatasetDatasource()
		const breakdown = _.first(chart.breakdowns.models)
		const datasetFields = breakdown.get('datasetFields') || []
		const dateFields = _.filter(dataset.get('fields'), f =>
			[DATE, DATE_TIME, CALENDAR_PERIOD].includes(f.dataType))
		if (dateFields.length == 1 && !datasetFields.length) {
			datasetFields.push({
				datasetId: dataset.id,
				datasetFieldId: dateFields[0].id
			})
			breakdown.set('datasetFields', datasetFields)
		}
	}

	chart.breakdowns.forEach(b => {
		let usedDatasets = _(chart.getAllDatasetIds())
			.map(id => chart.data.datasetModel(id))
			.compact().value()

		// #47221 Remove any datasetFields that reference a dataset that is no
		// longer used in a chart serie
		b.set('datasetFields', _.filter(b.get('datasetFields'), f => {
			if (f.datasetFieldId == null) {
				// No field has been chosen, which might trigger a validation
				// error, but that's okay: the user can fix it
				return true
			}

			let fieldIsInUsedDatasets = _.some(usedDatasets, dataset => {
				return dataset.combinedFieldsById[f.datasetFieldId] != null
			})

			return fieldIsInUsedDatasets
		}))

		// #54964 if there is only one serie left, the datasetField should have
		// serieId/TempId cleared out so that it applies to all series
		if (chart.getSerieFeatures().length < 2) {
			b.get('datasetFields').forEach(f => {
				delete f.serieId
				delete f.serieTempId
			})
		}

		if (_.isEmpty(b.get('datasetFields'))) {
			b.set('datasetFieldId', null)
		}
	})
}

function hasCalendarBreakdown (chart) {
	return chart.breakdowns.filter(b => b.isCalendarPeriodBreakdown()).length > 0
}

export default adjustBreakdownDatasetFields

adjustBreakdownDatasetFields.__filename__ = 'charts/edit/serie/adjust-breakdown-dataset-fields.js'
